

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "./Slider.css";
import styled from "styled-components";



const SliderImages = styled.img`
  width: auto;
    max-height: 430px;
    margin: 20px;
    border-radius: 7px;
    box-shadow: 1px 1px 10px 1px #aaaaaa7f;
  

  @media only screen and (max-width: 420px){    
    max-height: 380px;
    margin: auto;
  }
  @media only screen and (max-width: 400px){    
    max-height: 340px;
    margin: auto;
  }
`;




export default function Slide() {
    var settings = {
        className: "center",
        arrows:false,
        centerMode: false,
        centerPadding: "60px",
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        cssEase: "linear",
        dotsClass: 'Slider-dots',
        
        
        responsive: [            
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]


    };
    return (
        <div className="sli">
            <Slider {...settings}>

            <div><SliderImages className="" src="/assets/slider/1.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/2.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/3.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/4.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/5.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/6.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/7.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/8.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/9.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/10.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/11.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/12.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/13.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/14.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/15.png" alt=" "/></div>
            <div><SliderImages className="" src="/assets/slider/16.png" alt=" "/></div>

            
                
                             
            </Slider>
        </div>
    );
}
